// extracted by mini-css-extract-plugin
export default {"container":"ZB-z","dimension":"_B-z","dimensionLabels":"aC-z"};